import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({selector: '[focusable]'})
export class FocusableDirective implements AfterViewInit {

    constructor(private host: ElementRef) {
    }

    ngAfterViewInit() {
        setTimeout(() => this.host.nativeElement.focus());
    }
}
